import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { TimeInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/TextInput/TimeInput/TimeInput';
import { useEndTimeInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/TextInput/TimeInput/hooks/useEndTimeInput';
import { TimeIntervalTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export interface EndTimeInputProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function EndTimeInput({
  name,
  id,
  disabled = false,
}: EndTimeInputProps): JSX.Element {
  const { watch } = useFormContext<IMealCreditFormFields>();
  const rules = useEndTimeInput();

  const { timeIntervalType } = watch(['timeIntervalType']);

  const label =
    timeIntervalType === TimeIntervalTypeValues.OVERNIGHT
      ? 'End time (Next day)'
      : 'End time';

  return (
    <TimeInput
      label={label}
      name={name}
      id={id}
      disabled={disabled}
      rules={rules}
    />
  );
}
